import type { NRecords, TEmployee } from '@app/types';

export const adaptModelEmployeeRecords = (
  unhandledRecords: NRecords.ModelEmployeeRecords[] | null
): TEmployee[] => {
  const result = (unhandledRecords || []).map((item) => {
    const {
      NameFirst,
      NameLast,
      NameMiddle,
      NameFull,
      Photo,
      Position,
      PositionId,
      UserId,
      WorkSchedules,
    } = item;

    return {
      ...item,

      // Серверные свойства
      NameFirst: NameFirst || '',
      NameLast: NameLast || '',
      NameMiddle: NameMiddle || '',
      NameFull: NameFull || '',
      Photo: Photo || '',
      Position: Position || '',
      PositionId: PositionId || 0,
      WorkSchedules: WorkSchedules || [],

      // Фронтовые свойства
      value: UserId,
      label: `${NameLast ? `${NameLast} ` : ''}${NameFirst}`,
    };
  });

  return result;
};
